import { HttpHook } from './http-hook.class'
import { HOOK_PATH_MATCHING } from './http-hook.enum'
import { isBrowser } from '../../env'

const httpHook = isBrowser() ? { startHttpHook: () => { throw 'cannot use httphook on browser' } } : new HttpHook()
export { HOOK_PATH_MATCHING, httpHook }

export default {
  httpHook, 
  HOOK_PATH_MATCHING,
}
